import React, { Component } from 'react'
import TextField from 'material-ui/TextField'
import SelectField from 'material-ui/SelectField'
import FlatButton from 'material-ui/FlatButton'
import IconButton from 'material-ui/IconButton'
import Clear from 'material-ui/svg-icons/content/clear'
import Dialog from 'material-ui/Dialog'
import CheckCircle from 'material-ui/svg-icons/action/check-circle'
import Done from 'material-ui/svg-icons/action/done'
import MenuItem from 'material-ui/MenuItem'
import { Redirect } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { ALertHeaderText, AlertText } from '../Seminars/styles'
import { getTimezones, getToken } from '../../lib'

const allTimezones = getTimezones()

export default class SettingsForm extends Component {
 
  componentWillReceiveProps = (props) => {
    if (props.emailAlreadyGot) {
      this.setState({
        emailError: <FormattedMessage id="settings.emailAlreadyGot"/>
      })
    }
  }
  
  state = {
    name: this.props.name ? this.props.name : '',
    email: this.props.email ? this.props.email : '',
    password: '',
    nameError: null,
    emailError: null,
    passwordError: null,
    timeValue: this.props.timezone ? this.props.timezone : allTimezones[318],
    languageValue: this.props.userLanguauge
      ? this.props.userLanguauge === 'ja' ? 'jp' : this.props.userLanguauge
      : 'en',
    changedValues: 0,
    submitted: false,
    open: false,
    deleteName: '',
    confirmDelete: false
  }
  handleTimeChange = (event, index, timeValue) => {
    let {changedValues} = this.state
    changedValues++
    this.setState({timeValue, changedValues})
  }
  handleLanguageChange = (event, index, languageValue) => {
    let {changedValues} = this.state
    changedValues++
    this.setState({languageValue, changedValues})
  }

  deleteUser = () => {
    const token = getToken()
    if (!this.state.confirmDelete) {
      this.setState({confirmDelete: true})
    } else {
      this.props.deleteUser(token, this.props.userid)
    }
  }

  handleChange = (e, purpose) => {
    switch (purpose) {
      case 'name':
        return this.setState({name: e.target.value, nameError: null})
      case 'email':
        return this.setState({email: e.target.value, emailError: null})
      case 'password':
        return this.setState({password: e.target.value, passwordError: null})
      case 'deleteName':
        return this.setState({deleteName: e.target.value})
      default:
        return console.error('out of context')
    }
  }

  componentWillUnmount() {
    this.props.userUpdated(false)
  }

  handleOpen = () => this.setState({open: true})
  handleClose = () => this.setState({open: false})

  handleSubmit = e => {
    e.preventDefault()
    let post = true
    const {email, name, password, timeValue, languageValue} = this.state
    const emailFilter = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (name.length === 0) {
      this.setState({
        nameError: <FormattedMessage id="login.requiredField"/>
      })
      post = false
    } else {
      this.setState({nameError: null})
    }

    if (email.length === 0) {
      this.setState({
        emailError: <FormattedMessage id="login.requiredField"/>
      })
      post = false
    } else if (!emailFilter.test(email)) {
      this.setState({
        emailError: <FormattedMessage id="signUp.emailError"/>
      })
      post = false
    } else {
      this.setState({emailError: null})
    }

    if (password.length === 0) {
      this.setState({
        passwordError: <FormattedMessage id="login.requiredField"/>
      })
      post = false
    } else if (password.length < 8) {
      this.setState({
        passwordError: <FormattedMessage id="signUp.passwordError.short"/>
      })
      post = false
    }
    else if (password.length > 20 ) {
      this.setState({
        passwordError: <FormattedMessage id="signUp.passwordError.long"/>
      })
      post = false
    } else if (
      password.search(/\d/) === -1 ||
      password.search(/[a-zA-Z]/) === -1
    ) {
      this.setState({
        passwordError: (
          <FormattedMessage id="signUp.passwordError.alphaNumeric"/>
        )
      })
      post = false
    } else {
      this.setState({passwordError: null})
    }

    if (post) {
      const token = getToken()
      this.setState({submitted: true})
      this.props.updateUserDetails(
        token,
        this.props.userid,
        email,
        name,
        password,
        languageValue,
        timeValue
      )
    }
  }

  handleClear = () => {
    this.setState({
      name: this.props.name ? this.props.name : '',
      email: this.props.email ? this.props.email : '',
      password: ''
    })
    this.props.userUpdated(false)
  }
 
  render() {
    const divScroll={ overflowY: 'scroll'}
    const {name, email, password, confirmDelete, deleteName} = this.state
    const { accountType } = this.props;
    if (this.props.logoutSuccess) {
      return <Redirect to="/login"/>
    }
    return (
      <form className={this.props.view === 'desktop' ? "pl4 pr4" : "pl2 pr2"} onSubmit={this.handleSubmit}>
        <input style={{display: 'none'}} type="email" name="email"/>
        <input style={{display: 'none'}} type="password" name="password"/>

        <TextField
          onChange={e => this.handleChange(e, 'name')}
          value={name}
          fullWidth
          errorText={this.state.nameError}
          hintText="John"
          floatingLabelText={<FormattedMessage id="signUp.usernameLabel"/>}
        />
        <TextField
          onChange={e => this.handleChange(e, 'email')}
          fullWidth
          value={email}
          errorText={this.state.emailError}
          type="email"
          name="email"
          hintText="John"
          floatingLabelText={<FormattedMessage id="login.emailLable"/>}
        />
        <TextField
          onChange={e => this.handleChange(e, 'password')}
          fullWidth
          value={password}
          errorText={this.state.passwordError}
          type="password"
          name="password"
          hintText="********"
          floatingLabelText={<FormattedMessage id="login.passwordLable"/>}
        />
        <div/>
        {false && <SelectField
          selectedMenuItemStyle={{
            backgroundColor: 'rgba(136, 224, 168, 0.18)',
            color: '#29B87A'
          }}
          floatingLabelText={
            <FormattedMessage id="inviteModal.settings.timezone"/>
          }
          value={this.state.timeValue}
          dropDownMenuProps={{
            className: 'scroll'
          }}
          autoWidth
          className="scroll"
          onChange={this.handleTimeChange}
          menuStyle={{height: '10vh'}}
          menuItemStyle={{height: 48, paddingTop: 8}}
          style={{width: '100%', height: '10vh'}}
        >
          {allTimezones.map((val, index) => (
            <MenuItem
              key={index}
              value={val}
              primaryText={val}
              rightIcon={
                this.state.timeValue === {val} ? (
                  <CheckCircle style={{fill: '#29B87A'}}/>
                ) : (
                  <div/>
                )
              }
            />
          ))}
        </SelectField>}
        {false && <SelectField
          selectedMenuItemStyle={{
            backgroundColor: 'rgba(136, 224, 168, 0.18)',
            color: '#29B87A'
          }}
          floatingLabelText={
            <FormattedMessage id="inviteModal.settings.language"/>
          }
          value={this.state.languageValue}
          onChange={this.handleLanguageChange}
          menuItemStyle={{height: 48, paddingTop: 8}}
          autoWidth
          dropDownMenuProps={{
            anchorOrigin: {vertical: 'top', horizontal: 'right'},
            targetOrigin: {vertical: 'top', horizontal: 'right'}
          }}
          fullWidth
        >
          <MenuItem
            value="en"
            primaryText="English"
            rightIcon={
              this.state.languageValue === 'English' ? (
                <CheckCircle style={{fill: '#29B87A'}}/>
              ) : (
                <div/>
              )
            }
          />
          <MenuItem
            value="jp"
            primaryText="日本語"
            rightIcon={
              this.state.languageValue === '日本語' ? (
                <CheckCircle style={{fill: '#29B87A'}}/>
              ) : (
                <div/>
              )
            }
          />
        </SelectField>}
        {this.props.updated ? (
          <div className="flex w-100 items-center mb3">
            <div className="w-10">
              <Done color="green"/>
            </div>
            <div className="w-90 pr2 green">
              <FormattedMessage id="settings.saved"/>
            </div>
          </div>
        ) : (
          ''
        )}
        <div className="flex justify-between mt3">
          <div>
            <FlatButton
              onTouchTap={() => {
                this.setState({confirmDelete: false})
                this.handleOpen()
              }}
              label={<FormattedMessage id="contacts.delete"/>}
              hoverColor="#D0132A"
              backgroundColor="#F01631"
              labelStyle={{color: '#FFFFFF'}}
            />
          </div>
          <div>
            <FlatButton
              onTouchTap={this.handleClear}
              label={<FormattedMessage id="seminarActions.clear"/>}
              labelStyle={{color: '#AFB8C4'}}
            />
          </div>
          <div>
            {this.props.updated ? (
              ''
            ) : (
              <FlatButton
                className="ml2"
                type="submit"
                label={<FormattedMessage id="seminar.save"/>}
                hoverColor="#1d8e5d"
                backgroundColor="#29B87A"
                labelStyle={{color: '#FFFFFF'}}
              />
            )}
          </div>
        </div>
        <Dialog
          modal
          contentStyle={{ width: this.props.view === 'desktop' ? 'unset' : '95%' }}
          bodyStyle={{
            overflowY: 'auto',
            padding: this.props.view === 'mobile' || this.props.view === 'sm-mobile' ? '10px' : '20px'
          }}
          open={this.state.open}
          onRequestClose={this.handleClose}
        >
          <div>
            <div className="flex justify-between items-center">
              <ALertHeaderText>
                {this.state.confirmDelete ? (
                  <FormattedMessage id="settings.confirmDelete"/>
                ) : (
                  <FormattedMessage id="settings.deleteAccount"/>
                )}
              </ALertHeaderText>
              <div>
                <IconButton
                  onTouchTap={this.handleClose}
                  iconStyle={{fill: '#afb8c5'}}
                >
                  <Clear/>
                </IconButton>
              </div>
            </div>
            {this.state.confirmDelete ? (
              <div>
                <ALertHeaderText className="mb3">
                  <FormattedMessage id="settings.typeMessage.type"/>
                  {this.props.name}
                  <FormattedMessage id="settings.typeMessage.accountName"/>
                </ALertHeaderText>
                <div className="mb3">
                  <TextField
                    onChange={e => this.handleChange(e, 'deleteName')}
                    fullWidth
                    value={deleteName}
                    hintText={
                      <FormattedMessage id="settings.typeMessage.delete"/>
                    }
                    floatingLabelText={
                      <div>
                        <FormattedMessage id="settings.typeMessage.type"/>
                        {this.props.name}
                      </div>
                    }
                  />
                </div>
              </div>
            ) : (
              <div>
                <AlertText className="mt3 mb3">
                  <FormattedMessage id="settings.sureDelete"/>
                </AlertText>
                <ALertHeaderText className="mb3">
                  <FormattedMessage id="settings.deleteMessage"/>
                </ALertHeaderText>
              </div>
            )}
            <div className="flex justify-end">
              <div className="w4">
                <FlatButton
                  disabled={confirmDelete && deleteName !== this.props.name}
                  label={<FormattedMessage id="loggedInNavigation.cancel"/>}
                  style={{
                    opacity:
                      confirmDelete && deleteName !== this.props.name ? 0.2 : 1
                  }}
                  fullWidth
                  onTouchTap={this.handleClose}
                />
              </div>
              <div className="ml2 w6">
                <FlatButton
                  fullWidth
                  label={<FormattedMessage id="settings.deleteButtonLabel"/>}
                  disabled={confirmDelete && deleteName !== this.props.name}
                  style={{
                    opacity:
                      confirmDelete && deleteName !== this.props.name ? 0.2 : 1
                  }}
                  hoverColor="#D0132A"
                  backgroundColor="#F01631"
                  labelStyle={{color: '#FFFFFF'}}
                  onTouchTap={() => this.deleteUser()}
                />
              </div>
            </div>
          </div>
        </Dialog>
      </form>
    )
  }
}



// WEBPACK FOOTER //
// src/components/SettingsForm/SettingsForm.js